import { Record } from 'immutable'

export interface IEarnestMoneySummary {
  readonly pipelineId: string
  readonly pipelineName: string
  readonly depositDate?: number
  readonly amount: number
  readonly location: string
  readonly withdrawlDate?: number
  readonly balanceHolding: number
}

const EarnestMoneySummaryRecord = Record({
  amount: 0,
  balanceHolding: 0,
  depositDate: undefined,
  location: '',
  pipelineId: '',
  pipelineName: '',
  withdrawlDate: undefined,
})

export class EarnestMoneySummary extends EarnestMoneySummaryRecord
  implements IEarnestMoneySummary {
  public static fromJS(initialState?: Partial<IEarnestMoneySummary>) {
    if (!initialState) {
      return new EarnestMoneySummary()
    }

    const { ...rest } = initialState

    return new EarnestMoneySummary({
      ...rest,
    })
  }

  public readonly pipelineId: string
  public readonly pipelineName: string
  public readonly depositDate?: number
  public readonly amount: number
  public readonly location: string
  public readonly withdrawlDate?: number
  public readonly balanceHolding: number

  constructor(initialState?: Partial<EarnestMoneySummary>) {
    initialState ? super(initialState) : super()
  }
}
